import { initCharts } from './charts';

export function initDashboard(): void {
  const form = document.querySelector<HTMLFormElement>('#dashboard-filter-form');
  const container = document.querySelector<HTMLElement>('#invoicing-chart-container');
  if (!form || !container) return;

  const chartUrl = container.dataset.chartUrl;
  if (!chartUrl) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const params = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);

    fetch(`${chartUrl}?${params.toString()}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((r) => {
        if (!r.ok) throw new Error('Server error: ' + r.status);
        return r.text();
      })
      .then((html) => {
        container.innerHTML = html;
        initCharts(container);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Dashboard chart fetch error:', err);
      });
  });
}
